import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-brand',
  templateUrl: './hotel-brand.component.html',
  styleUrls: ['./hotel-brand.component.scss']
})
export class HotelBrandComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/hotels/hotel-management/hotel-brand/hotel-brand.component.ts